const moment = require('moment')

module.exports = function(timestamp) {
  if (timestamp) {
    return moment(timestamp).fromNow()
  }
}
